import { getApiEndpoint } from '~/api/auth';
import type { IndexData } from '~/api/types';
import { authFetch } from '~/api/utils';

export const getIndexData = async (): Promise<IndexData> => {
  return await authFetch(getApiEndpoint() + 'main', {
    method: 'GET',
  });
};
